"use strict";

jQuery(document).ready(function($) {
    var collection = $('.custom_slider_multiple_items');
    if (collection.length > 0) {
        $(collection).slick({
            slidesToShow: 8,
            slidesToScroll: 1,
            autoplay: false,
            prevArrow: '<span class="prev"><</span>',
            nextArrow: '<span class="next">></span>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true,
                        autoplay: true,
                        autoplaySpeed: 2000
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        autoplay: true,
                        autoplaySpeed: 2000
                    }
                }
            ]
        });
    }

    var mobileBar = $('.custom-announcement-bar .custom-messages');
    if (mobileBar.length > 0) {
        $(mobileBar).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            prevArrow: '<span class="prev"><svg width="20" height="36" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t<path d="M9 17L1 9L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
                '</svg></span>',
            nextArrow: '<span class="next"><svg width="20" height="36" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t<path d="M1 1L9 9L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
                '</svg></span>',
        });
    }

    var brands = $('.brands .brands__items');
    if (brands.length > 0) {
        $(brands).slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            prevArrow: '<span class="prev"><svg width="20" height="36" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t<path d="M9 17L1 9L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
                '</svg></span>',
            nextArrow: '<span class="next"><svg width="20" height="36" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t<path d="M1 1L9 9L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
                '</svg></span>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }

    var landing = $('.landing-slider_wrap .products');
    if (landing.length > 0) {
        $(landing).slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
            infinite: true,
            arrows: true,
            prevArrow: '<span class="landing-prev"><span class="landing-prev-wrap"><</span>',
            nextArrow: '<span class="landing-next"><span class="landing-next-wrap">></span>',
            responsive: [
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    var icon = $('.multiple-items');
    if (icon.length > 0) {
        $(icon).slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: false,
            prevArrow: '<span class="prev"><svg width="20" height="36" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t<path d="M9 17L1 9L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
                '</svg></span>',
            nextArrow: '<span class="next"><svg width="20" height="36" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '\t<path d="M1 1L9 9L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
                '</svg></span>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
});